
export const checkoutAddressReducer = (state = null, action) => {
    if (action.type === 'CHECKOUT_ADDRESS') {
        return action.payload || null;
    }
    return state;
}

export const checkoutReviewOrderReducer = (state = null, action) => {
    if (action.type === 'CHECKOUT_REVIEW_ORDER') {
        return action.payload;
    }
    return state;
}
export const buyNowReducer = (state = null, action) => {
    if (action.type === 'BUY_NOW') {
        return action.payload;
    }
    return state;
}
export const cartIdReducer = (state = null, action) => {
    if (action.type === 'CART_ID') {
        return action.payload;
    }
    return state;
}
export const activePaymentReducer = (state = null, action) => {
    if (action.type === 'ACTIVE_PAYMENT_OPTION') {
        return action.payload;
    }
    return state;
}